import { CURRENCY_STORAGE_KEY, CURRENCY_STORAGE_LOCK_KEY } from './constants.js';

export type Currency = 'USD' | 'CAD';

export function getStoredCurrency(): Currency {
  const v = (typeof window !== 'undefined' && window.localStorage.getItem(CURRENCY_STORAGE_KEY)) || null;
  return v === 'CAD' ? 'CAD' : 'USD';
}

export function setStoredCurrency(currency: Currency) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(CURRENCY_STORAGE_KEY, currency);
}

export function markCurrencyUserSet() {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(CURRENCY_STORAGE_LOCK_KEY, '1');
}

export function isCurrencyUserSet(): boolean {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(CURRENCY_STORAGE_LOCK_KEY) === '1';
}

export function formatMoney(amount: number, currency: Currency) {
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
  } catch {
    // Fallback
    const symbol = currency === 'CAD' ? 'CA$' : '$';
    return `${symbol}${amount.toFixed(2)}`;
  }
}
